import {IFormFields, Login, loginFormFactory} from 'core/components/login'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Redirect, RouteComponentProps, withRouter} from 'react-router'
import Card from 'study_coordinator/components/Card'
import * as routes from 'study_coordinator/routes'
import {IState, loginRequest} from 'study_coordinator/store'
import * as styles from './LoginPage.css'

interface IStateProps {
  isLoggedIn: boolean
}
interface IDispatchProps {
}
interface IOwnProps extends RouteComponentProps<void> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

const LOGIN_FORM_NAME = 'login'
const onSubmit = (data: IFormFields, dispatch: Dispatch<void>) => {
  dispatch(loginRequest(data, LOGIN_FORM_NAME))
}
const LoginForm = loginFormFactory({formName: LOGIN_FORM_NAME, onSubmit})

class LoginPage extends React.Component<IProps, {}> {
  public render() {
    const {isLoggedIn} = this.props
    if (isLoggedIn) return this.redirectToReferrer()

    return (
      <div className={styles.page}>
        <Card>
          <Login
            {...routeProps<IProps, void>(this.props)}
            renderForm={() => <LoginForm theme={{error: styles.error}} />}
            theme={{graphic: styles.graphic, lettering: styles.lettering}}
          />
        </Card>
      </div>
    )
  }

  private redirectToReferrer() {
    const from = this.props.location.state && this.props.location.state.from
    if (!from || from.pathname === routes.loginRoute() || from.pathname === routes.logoutRoute()) {
      return <Redirect to={routes.rootRoute()} />
    }
    return <Redirect to={from} />
  }
}

const mapStateToProps = (state: IState): IStateProps => ({
  isLoggedIn: !!state.login.token,
})

export default withRouter(
  connect<IStateProps, IDispatchProps, IOwnProps, IState>(mapStateToProps)(LoginPage),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/pages/LoginPage.tsx